export interface HcProfileEntity {
  employeeID: string;
  binusianID: string;
  workEmail: string;
  businessUnit: string;
  username: string;
  password: string;
  tokenMngBu: string;
  mail: string;
  displayName: string;
}

export namespace HcProfileEntity {
  export function fromJson(json): HcProfileEntity {
    return {
      binusianID: json.binusianID,
      businessUnit: json.businessUnit,
      displayName: json.displayName,
      employeeID: json.employeeID,
      mail: json.mail,
      password: json.password,
      tokenMngBu: json.tokenMngBu,
      username: json.username,
      workEmail: json.workEmail,
    };
  }
}
